import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";
import { ICreateDocumentoUseCase } from "../../../presentation/useCases/create/create_documento_use_case";
import { FileUtils } from "../../../../../common/utils/file_utils";


export class CreateDocumentoUseCase implements ICreateDocumentoUseCase {
  constructor(
    private readonly repository: ITerceirizacaoRepository,
  ) { }

  async createDocumento(
    idFuncionario: number,
    statusArquivo: number | null,
    nomeDocumento: string,
    dataVencimento: Date | null,
    file: File | null,
  ): Promise<void> {
    await this.repository.createDocumento(
      idFuncionario,
      nomeDocumento,
      statusArquivo,
      dataVencimento,
      await this.getFilename(file),
      file,
    );
  }

  private async getFilename(file: File | null): Promise<string | null> {
    if (file === null) return null;
    return file.name;
  }

  private async convertToBase64(file: File | null): Promise<string | null> {
    return await FileUtils.readFileAsBase64(file);
  }
}